
import { all, call, put, takeLatest, select } from 'redux-saga/effects';

import { Code } from 'actions/actionTypes';
import * as actions from 'actions/common/code';

import { callCodeList } from 'network/apis/common/code';

function* loadCodeListRequestSaga() {
    try {
        const code = yield select(state => state.code);
        
        const response = yield call(callCodeList, code.codeGroup);

        yield put(actions.loadCodeListSuccess(response.data));
    } catch(error) {
        yield put(actions.loadCodeListFailure(error.message));
    }
}

// Sign-In Sagas
export default function* root() {
    yield all([
        takeLatest(Code.LOAD_CODE_LIST_REQUEST, loadCodeListRequestSaga),
    ]);
}